import { ITEM_API } from "../constants/api";
import {
  getHeadersWithTokenAndTraderId,
  getUrl,
  optionsGet,
} from "./commonService";
import customAxios from "./customAxios";

export default class ItemService {
  getItemsService(params: any) {
    const url = getUrl(ITEM_API.LIST);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }

  getItemsByAddressAndDateService(params: any) {
    let api = ITEM_API.LIST_BY_ADDRESS_AND_DATE;
    api = api.replace("#ADDRESSID#", params.addressId);
    api = api.replace("#DATE#", params.dt);
    api = api.replace("#ISSAMEDAYORDER#", params.isSameDayOrder?params.isSameDayOrder:false);
    api = api.replace("#ITEMNAME#", params.name ? params.name : "");
    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }

  getItemDetail(params: any) {
    let api = ITEM_API.DETAIL;
    api = api.replace("#ITEMID#", params.itemId);
    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }
}
